import React from 'react';

/**
 * En-tête homogène : petit sur-titre, titre, et filet central terminé par une
 * « balle ». Utilisé pour les sections de l'accueil (h2) et pour le titre des
 * pages intérieures (`as="h1"`), afin d'unifier toute la typographie.
 */
function SectionTitle({ overline, children, id, as = 'h2', className = '' }) {
  const Heading = as;
  return (
    <div className={`section-title ${className}`.trim()}>
      {overline && <span className="section-title-overline">{overline}</span>}
      <Heading id={id}>{children}</Heading>
      <span className="section-title-rule" aria-hidden="true" />
    </div>
  );
}

export default SectionTitle;
